<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button class="mr15" type="primary" @click="markAsReadBtn">{{ $t('key1002453') }}</Button>
      <p class="tips_text mr15">
        {{ $t('key1002454') }} <span style="color: #2D8CF0;">{{ totalNumberOfMessages }}</span> {{ $t('key1002455') }} <span style="color: #f30606">
        {{ systemAnnouncementUnreadTotal + messageNotificationTotal }}</span> {{ $t('key1001120') }}
      </p>
    </div>
    <Tabs v-model="tabStatus" :animated="false" class="tabs_styles">
      <TabPane v-for="item in statusList" :label="handleLable(item)" :name="item.value"></TabPane>
    </Tabs>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        :loading="tableLoading"
        border
        max-height="600"
        :columns="tableColumns"
        @on-selection-change="tableChange"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--查看系统公告弹窗-->
    <viewAnnouncementModal ref="viewAnnouncement" @updateData="pageParamsStatus = true"></viewAnnouncementModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import viewAnnouncementModal from "@/components/common/viewAnnouncementModal.vue";
import {getMenuRoutingId} from "@/utils/common";

export default {
  name: "messageCenter",
  components: {viewAnnouncementModal},
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        pageSize: 15,
        pageNum: 1
      },
      total: 0,
      tableColumns: [
        {
          type: 'selection',
          width: 70,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002450'),
          key: 'title',
          align: 'left',
          render(h, params) {
            let informationType = params.row.informationType;
            let triggerType = params.row.triggerType;
            let triggerValue = params.row.triggerValue || 0;
            // hasRead 是否已读 0 未读 1已读 ,
            let hasRead = params.row.hasRead === 0;
            let arr = [
              h('div', {
                class: 'flex align-items-center',
                style: {
                  position: 'relative'
                }
              }, [
                hasRead ? h('span', {
                  class: 'unread_message_styles'
                }) : '',
                h('h3', {
                  style: {
                    fontSize: '14px',
                    color: hasRead ? '#333' : v.tabStatus === '2' ? '#2D8CF0' : '',
                    marginBottom: '5px',
                    cursor: v.tabStatus === '2' ? 'pointer' : null
                  },
                  class: hasRead ? 'font-weight-bold' : ''
                }, params.row.title)
              ]),
              h('p', {
                domProps: {
                  innerHTML: params.row.content
                },
                on: {
                  click: (event) => {
                    event.stopPropagation();
                    // 系统公告
                    if (v.tabStatus === '1') {
                      let noticeInfoId = params.row.noticeInfoId;
                      v.$refs['viewAnnouncement'].markAsReadBtn(noticeInfoId).then(() => {
                        v.pageParamsStatus = true;
                        v.$refs['viewAnnouncement'].getViewAnnouncementData(noticeInfoId);
                      });
                    }
                    // 消息通知
                    else {
                      // 2备货超时、3拣货超时、4换单超时、5装箱超时、6发货超时
                      if ([2, 3, 4, 5, 6].includes(informationType)) {
                        let id = getMenuRoutingId('/orderList');
                        localStorage.setItem('activeName', id);
                        let nowDate = new Date();
                        let time = new Date();
                        let tagTime = time.setMonth(nowDate.getMonth() - 6);
                        let updatedStartTime = v.$uDate.getDateTime(tagTime, 'fulltime');
                        let updatedEndTime = '';
                        // 天
                        if (triggerType === 'd') {
                          let val = nowDate.getDate() - Number(triggerValue);
                          updatedEndTime = v.$uDate.getDateTime(val, 'fulltime');
                        }
                        // 小时
                        if (triggerType === 'h') {
                          let val = nowDate.getTime() - (Number(triggerValue) * 60 * 60 * 1000);
                          updatedEndTime = v.$uDate.getDateTime(val, 'fulltime');
                        }
                        let obj = {
                          updatedStartTime: updatedStartTime,
                          updatedEndTime: updatedEndTime,
                          informationType: informationType
                        };
                        localStorage.setItem('orderListQuery', JSON.stringify(obj));
                        v.$store.commit('updateSystemMenu', true);
                        setTimeout(() => {
                          v.$router.push({
                            path: '/orderList',
                          });
                        }, 200);
                      }
                    }
                  }
                }
              })
            ];
            return h('div', {
              style: {
                cursor: 'pointer',
                padding: '8px 0'
              },
              on: {
                click: () => {
                  if (v.tabStatus === '2') {
                    let ymsStationNotificationId = params.row.ymsStationNotificationId;
                    if (ymsStationNotificationId) {
                      v.viewMessage(params.row);
                    }
                  }
                }
              }
            },
            arr);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002451'),
          key: 'time',
          align: 'center',
          width: 200,
          sortable: true,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        }
      ],
      tableData: [],
      selectTableData: [],
      statusList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001126'), value: '1', total: 0},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000675'), value: '2', total: 0}
      ],
      tabStatus: '1',
      systemParams: {
        isRead: null, // 是否已读 null全部 0否 1是
        pageNum: 1,
        pageSize: 15,
        subsystemName: 'yms',
      },
      systemAnnouncementUnreadTotal: 0,
      messageNotificationTotal: 0,
      totalNumberOfMessages: 0
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    // 标记为已读
    markAsReadBtn() {
      let v = this;
      if (v.selectTableData.length > 0) {
        let ymsStationNotificationIds = [];
        v.selectTableData.map((item) => {
          if (v.tabStatus === '2') {
            ymsStationNotificationIds.push(item.ymsStationNotificationId);
          } else {
            ymsStationNotificationIds.push(item.noticeInfoId);
          }
        });
        if (ymsStationNotificationIds.length > 0) {
          if (v.tabStatus === '2') {
            v.axios.post(api.post_ymsStationNotification_batchRead, ymsStationNotificationIds,
              {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
                v.selectTableData = [];
                v.pageParamsStatus = true;
                v.getMessageNotificationData(api.get_ymsStationNotification_lastUnRead);
              }
            });
          } else {
            v.axios.post(api.post_ymsNoticeInfo_disable, ymsStationNotificationIds, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
                v.selectTableData = [];
                v.pageParamsStatus = true;
                v.getMessageNotificationData(api.get_ymsStationNotification_lastUnRead);
              }
            });
          }
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002452'));
        return false;
      }
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.tableLoading = true;
      v.axios.post(api.post_ymsStationNotification_query, v.pageParams).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          v.tableData = data.list || [];
          v.total = data.total;
          v.$nextTick(() => {
            v.tableLoading = false;
          });
        } else {
          v.tableLoading = false;
        }
      });
    },
    // 获取未读的个数
    getNumbers() {
      let v = this;
      v.systemAnnouncementUnreadTotal = 0;
      v.messageNotificationTotal = 0;

      // 获取消息通知未读数据
      function getNotification() {
        return new Promise((resolve) => {
          v.axios.get(api.get_ymsStationNotification_count).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              resolve(data);
            }
          });
        });
      }

      // 获取系统公告未读数据
      function getSystemAnnouncement() {
        return new Promise((resolve) => {
          let query = {
            merchantId: v.userInfo.merchantId,
            subsystemName: 'yms'
          };
          v.axios.post(api.post_ymsNoticeInfo_queryNoticeInfoCount, query).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              resolve(data);
            }
          });
        });
      }

      Promise.all([getNotification(), getSystemAnnouncement()]).then(result => {
        let notice = result[0];
        let announcement = result[1];
        v.messageNotificationTotal = notice.unReadCount || 0;
        let unReadCount = announcement.filter((item) => {
          return item.isRead === 0;
        });
        v.systemAnnouncementUnreadTotal = unReadCount[0].countNum || 0;
        let systemAnnouncementTotal = announcement.reduce((accumulator, currentValue) => {
          return accumulator + currentValue.countNum;
        }, 0);
        v.totalNumberOfMessages = notice.totalCount + systemAnnouncementTotal;
        v.statusList.map((item) => {
          item.value === '1' ? item.total = v.systemAnnouncementUnreadTotal : item.total = v.messageNotificationTotal;
        });
        v.$forceUpdate();
      });
    },
    // 处理消息的数量
    handleLable(data) {
      return data.name + (data.total ? `(${data.total})` : '');
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = data;
    },
    // 查看当前消息
    viewMessage(data) {
      let v = this;
      v.axios.post(api.post_ymsStationNotification_batchRead, [data.ymsStationNotificationId], {loading: true}).then(response => {
        if (response.data.code === 0) {
          v.$router.push({
            path: '/messageMailboxes',
            query: {
              ymsReceiveStationNotificationLogId: data.ymsReceiveStationNotificationLogId
            }
          });
          v.getMessageNotificationData(api.get_ymsStationNotification_lastUnRead);
        }
      });
    },
    // 获取系统公告数据
    getSystemAnnouncementData() {
      this.tableData = [];
      this.total = 0;
      this.systemParams.merchantId = this.userInfo.merchantId;
      this.tableLoading = true;
      this.axios.post(api.post_ymsNoticeInfo_queryNewNoticeInfo, this.systemParams).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          let list = data.list || [];
          this.total = data.total;
          if (list.length > 0) {
            list.map((item) => {
              item.hasRead = item.isRead;
              item['content'] = `<span class="themeColor cursor">${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002449')}</span>`;
            });
            this.tableData = list;
            this.$nextTick(() => {
              this.tableLoading = false;
            });
          } else {
            this.tableLoading = false;
          }
        } else {
          this.tableLoading = false;
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getNumbers();
        if (v.tabStatus === '2') {
          v.getList();
        } else {
          v.getSystemAnnouncementData();
        }
        v.pageParamsStatus = false;
      }
    },
    tabStatus: {
      handler(val) {
        this.getNumbers();
        if (val === '1') {
          this.getSystemAnnouncementData();
        } else {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.operation_box {
  align-items: center;

  .tips_text {
    color: #333;
    font-size: 17px;
    font-weight: bold;
  }
}

.table_box /deep/ .unread_message_styles {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  position: absolute;
  left: -14px;
  top: 5px;
  background-color: #2D8CF0;
}
</style>
